import { gql } from '@apollo/client';

export const GET_MATCHES = gql`
  query GetMatches($matchWeekId: ID, $seasonCompetitionId: ID) {
    getMatches(matchWeekId: $matchWeekId, seasonCompetitionId: $seasonCompetitionId) {
      matches {
        id
        matchDate
        goalsHome
        goalsAway
        status
        homeTeam {
          id
          nameShow
          shortName
          shield
          shieldPng
        }
        awayTeam {
          id
          nameShow
          shortName
          shield
          shieldPng
        }
      }
      standings {
        id
        position
        team {
          id
          nameShow
          shortName
          shield
          shieldPng
        }
        points
        played
        goalsFor
        goalsAgainst
      }
      currentMatchWeek {
        id
        weekNumber
        startDate
        endDate
      }
      hasPrevious
      hasNext
      previousMatchWeekId
      nextMatchWeekId
      seasonCompetitionId
    }
  }
`;
